import { render, staticRenderFns } from "./IdCardlist.vue?vue&type=template&id=3dd359d4&scoped=true&"
import script from "./IdCardlist.vue?vue&type=script&lang=js&"
export * from "./IdCardlist.vue?vue&type=script&lang=js&"
import style0 from "./IdCardlist.vue?vue&type=style&index=0&id=3dd359d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd359d4",
  null
  
)

export default component.exports